<template>
  <div class="clerkCircle_container">
    <van-tabs
      class="clerkCircle_tabs"
      v-model="active"
      sticky
      title-active-color="#2D2A2B"
      title-inactive-color="#666666"
      @change="handleChangeTab"
    >
      <van-tab title="所有圈子">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
          class="clerkCircle_cards"
        >
          <div
            class="card_item"
            v-for="(item, index) in allList"
            :key="item.id"
            :style="{background: bgColorList[index % 6]}"
          >
            <div class="item_title">{{ item.circleName }}</div>
            <div class="item_game_content">
              <div
                class="item_game"
                v-for="category in item.categoryNames"
                :key="category"
              >{{category}}</div>
            </div>
            <div class="item_creator">创建人：{{ item.kfName }}</div>
            <div class="item_joinedClerk">
              <div class="join_tips" v-if="item.managerSum === 0">
                <img class="join_img" src="/static/images/163/plus.png" />
                <span class="join_text">快来加入吧~</span>
              </div>
              <div v-else class="joined_tips">
                <img v-for="avatar in item.avatarUrls" :key="avatar" :src="avatar" />
              </div>
              <div class="join_user">
                <img class="join_user_img" src="/static/images/163/user-icon.png" />
                <span class="join_user_num">{{ item.managerSum }}</span>
              </div>
            </div>
            <div v-if="item.joinStatus && item.joinStatus === 1" class="join_btn exit_audit">已加入</div>
            <div v-else class="join_btn" @click="handleJoinDialog(item)">我要加入</div>
          </div>
          <div slot="finished">没有更多了</div>
        </van-list>
      </van-tab>
      <van-tab title="我的圈子">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
          class="clerkCircle_cards"
        >
          <div
            class="card_item"
            v-for="(item, index) in allList"
            :key="item.id"
            :style="{background: bgColorList[index % 7]}"
          >
            <div class="item_title">{{ item.circleName }}</div>
            <div class="item_game_content">
              <div
                class="item_game"
                v-for="category in item.categoryNames"
                :key="category"
              >{{category}}</div>
            </div>
            <div class="item_creator">创建人：{{ item.kfName }}</div>
            <div class="item_joinedClerk">
              <div class="join_tips" v-if="item.managerSum === 0">
                <img class="join_img" src="/static/images/163/plus.png" />
                <span class="join_text">快来加入吧~</span>
              </div>
              <div v-else class="joined_tips">
                <img v-for="avatar in item.avatarUrls" :key="avatar" :src="avatar" />
              </div>
              <div class="join_user">
                <img class="join_user_img" src="/static/images/163/user-icon.png" />
                <span class="join_user_num">{{ item.managerSum }}</span>
              </div>
            </div>
            <div v-if="item.applyStatus === 0" class="join_btn exit_audit">退圈审核中</div>
            <div v-else class="join_btn" @click="handleExitJoinDialog(item)">退出圈子</div>
          </div>
          <div slot="finished">没有更多了</div>
        </van-list>
      </van-tab>
    </van-tabs>
    <van-dialog v-model="joinDialog" :show-confirm-button="false" close-on-click-overlay>
      <template v-if="currentData">
        <div class="joinDialog_header">
          <div class="header_title">加入圈子</div>
          <van-icon name="cross" @click="joinDialog = false" />
        </div>
        <div class="joinDialog_title">{{ currentData.circleName }}</div>
        <div class="joinDialog_label">
          音色:
          <div class="upload_content">
            <div v-if="data.soundCardUrl.length > 0" class="video_container">
              <van-icon name="clear" size="18" @click="data.soundCardUrl = []" />
              <video ref="soundCardUrlRef" class="video_content" :src="data.soundCardUrl[0]"></video>
              <van-icon name="play-circle" size="30" @click="handlePlayVideo('soundCardUrlRef')" />
            </div>
            <van-uploader
              v-else
              v-model="data.soundCardUrl"
              accept="video/*"
              :preview-image="false"
              :max-count="1"
              :max-size="15 * 1024 * 1024"
              @oversize="onOversize"
              :after-read="soundCardUrlRead"
            >
              <div class="upload_btn">
                <van-icon name="plus" />添加视频
              </div>
            </van-uploader>
          </div>
        </div>
        <div class="joinDialog_label">
          才艺视频:
          <div class="upload_content">
            <div v-if="data.talentVideo.length > 0" class="video_container">
              <van-icon name="clear" size="18" @click="data.talentVideo = []" />
              <video ref="talenvideoRef" class="video_content" :src="data.talentVideo[0]"></video>
              <van-icon name="play-circle" size="30" @click="handlePlayVideo('talenvideoRef')" />
            </div>
            <van-uploader
              v-else
              v-model="data.talentVideo"
              accept="video/*"
              :preview-image="false"
              :max-count="1"
              :max-size="15 * 1024 * 1024"
              @oversize="onOversize"
              :after-read="talentVideoRead"
            >
              <div class="upload_btn">
                <van-icon name="plus" />添加视频
              </div>
            </van-uploader>
          </div>
        </div>
        <div class="joinDialog_bottom">
          <div class="joinDialog_btn" @click="handleApply">申请加入</div>
        </div>
      </template>
    </van-dialog>
    <van-dialog v-model="exitJoinDialog" :show-confirm-button="false" close-on-click-overlay>
      <template v-if="currentData">
        <div class="joinDialog_header">
          <div class="header_title">退出圈子</div>
          <van-icon name="cross" @click="exitJoinDialog = false" />
        </div>
        <div class="joinDialog_title">确定要退出“{{currentData.circleName}}”吗？</div>
        <div class="exitDialog_desc">退圈说明：</div>
        <van-field
          v-model="applyDesc"
          class="applyDesc_input"
          rows="8"
          autosize
          type="textarea"
          placeholder="请输入"
        />
        <div class="exitDialog_bottom">
          <div class="exitDialog_primary" @click="handleSubmitExit">确认退出</div>
          <div class="exitDialog_default" @click="exitJoinDialog = false">我再想想</div>
        </div>
      </template>
    </van-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import { Tab, Tabs, Toast, List, Dialog, Icon, Uploader, Field } from "vant";
Vue.use(Tab)
  .use(Tabs)
  .use(Toast)
  .use(Dialog)
  .use(Icon)
  .use(Field)
  .use(Uploader)
  .use(List);

import {
  getClerkCircleList,
  applyCirCle,
  exitCircle,
  getUrlByClerk
} from "@/api/163/clerk/clerkCircle";
import { uploadFile } from "@/api/cos";

export default {
  name: "clerkCircle",
  data() {
    return {
      active: 0,
      allList: [],
      bgColorList: [
        "linear-gradient(0deg, #FBEAFB, #EADBFB)",
        "linear-gradient(0deg, #DEF4FF, #BDFCED)",
        "linear-gradient(0deg, #D8F6FE, #D2E5FE)",
        "linear-gradient(0deg, #DEE5FE, #DED5FB)",
        "linear-gradient(0deg, #E9E5FD, #C5E2FE)",
        "linear-gradient(0deg, #FCEED4, #FEF2BC)"
      ],
      loading: false,
      finished: false,
      joinDialog: false,
      page: {
        pageNo: 1,
        pageSize: 10,
        total: 0
      },
      currentData: null,
      data: {
        clerkId: null,
        circleId: null,
        talentVideo: [],
        soundCardUrl: []
      },
      exitJoinDialog: false,
      applyDesc: ""
    };
  },
  computed: {
    clerkId() {
      return this.$store.state.shop.id;
    }
  },
  methods: {
    handleChangeTab() {
      this.finished = false;
      this.getClerkCircleList(true);
    },
    async getUrlByClerk() {
      const { data: res } = await getUrlByClerk();
      if (res.code === 0) {
        if (res.data.soundCardUrl) {
          this.data.soundCardUrl = [res.data.soundCardUrl];
        }
        if (res.data.talentVideo) {
          this.data.talentVideo = [res.data.talentVideo];
        }
      }
    },
    async getClerkCircleList(isInit = false) {
      if (isInit) {
        this.allList = [];
        this.page.pageNo = 1;
      }
      this.loading = true;
      const { data: res } = await getClerkCircleList({
        pageNo: this.page.pageNo,
        pageSize: this.page.pageSize,
        qFlag: "page",
        flag: this.active === 0 ? undefined : "1"
      });
      if (res.code === 0) {
        res.data.map(item => {
          item.avatarUrls = item.avatarUrls.splice(0, 6);
        });
        this.allList = [...this.allList, ...res.data];
        this.page.total = res.total;
      }
      this.loading = false;
    },
    onLoad() {
      if (this.page.total > this.allList.length) {
        this.page.pageNo++;
        this.getClerkCircleList();
      } else {
        this.finished = true;
      }
    },
    handleJoinDialog(data) {
      this.data = {
        clerkId: null,
        circleId: null,
        ...this.data
      };

      this.joinDialog = true;
      this.currentData = { ...data };
    },
    handleExitJoinDialog(data) {
      this.applyDesc = "";
      this.exitJoinDialog = true;
      this.currentData = { ...data };
    },
    talentVideoRead(file) {
      uploadFile(this.$store.state.shop.id, "clerk/circle", file.file)
        .then(url => {
          Toast.clear();
          this.data.talentVideo = [url];
        })
        .catch(err => {
          Dialog.alert({
            title: "上传失败",
            message: err
          });
          this.data.talentVideo = [];
        })
        .finally(() => {
          Toast.clear();
        });
    },
    soundCardUrlRead(file) {
      uploadFile(this.$store.state.shop.id, "clerk/circle", file.file)
        .then(url => {
          Toast.clear();
          this.data.soundCardUrl = [url];
        })
        .catch(err => {
          Dialog.alert({
            title: "上传失败",
            message: err
          });
          this.data.soundCardUrl = [];
        })
        .finally(() => {
          Toast.clear();
        });
    },
    onOversize() {
      Toast("文件大小不能超过15M");
    },
    handlePlayVideo(ref) {
      //   this.requestFullscreen(this.$refs[ref])
      this.$refs[ref].play();
    },
    requestFullscreen(ele) {
      // 全屏兼容代码
      if (ele.requestFullscreen) {
        ele.requestFullscreen();
      } else if (ele.webkitRequestFullscreen) {
        ele.webkitRequestFullscreen();
      } else if (ele.mozRequestFullScreen) {
        ele.mozRequestFullScreen();
      } else if (ele.msRequestFullscreen) {
        ele.msRequestFullscreen();
      }
    },
    async handleApply() {
      if (
        this.data.talentVideo.length === 0 &&
        this.data.soundCardUrl.length === 0
      ) {
        Toast("至少上传音色/才艺视频其中一种");
        return false;
      }
      const { data: res } = await applyCirCle({
        clerkId: this.clerkId,
        circleId: this.currentData.id,
        talentVideo: this.data.talentVideo ? this.data.talentVideo[0] : null,
        soundCardUrl: this.data.soundCardUrl ? this.data.soundCardUrl[0] : null
      });
      if (res.code === 0) {
        this.joinDialog = false;
        Toast("已发起加入圈子申请");
        this.getClerkCircleList(true);
      } else {
        Toast(res.msg);
      }
    },
    async handleSubmitExit() {
      if (!this.applyDesc) {
        return Toast("请输入退圈说明");
      }
      const { data: res } = await exitCircle({
        applyDesc: this.applyDesc,
        clerkId: this.clerkId,
        circleId: this.currentData.id
      });
      if (res.code === 0) {
        Toast("已发起退圈申请");
        this.exitJoinDialog = false;
        this.getClerkCircleList(true);
      } else {
        Toast(res.msg);
      }
    }
  },
  mounted() {
    this.getClerkCircleList();
    this.getUrlByClerk();
  }
};
</script>

<style lang="less">
.clerkCircle_container {
  .clerkCircle_tabs {
    .van-tabs__line {
      background: linear-gradient(90deg, #16edcd, #1d7fed);
      border-radius: 2px;
    }
  }
  .clerkCircle_cards {
    position: relative;
    box-sizing: border-box;
    background-color: #fff;
    width: 100%;
    padding: 10px 16px;
    padding-bottom: 80px;
    column-count: 2;
    column-gap: 10px;
    width: 100%;
    margin: 0 auto;
    .van-list__finished-text {
      margin: 0 auto;
      position: absolute;
      left: 50%;
      margin-top: 50px;
      transform: translateX(-50%);
      bottom: -10px;
    }
    .card_item {
      width: 167px;
      height: fit-content;
      box-sizing: border-box;
      -webkit-column-break-inside: avoid;
      break-inside: avoid;
      padding: 16px;
      margin-bottom: 10px;
      margin-right: 10px;
      border-radius: 12px;
      .item_title {
        font-weight: bold;
        font-size: 15px;
        color: #191817;
        margin-bottom: 10px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .item_game_content {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        margin-bottom: 28px;
        .item_game {
          width: fit-content;
          font-weight: 500;
          font-size: 12px;
          color: #454a5b;
          background: rgba(255, 255, 255, 0.7);
          border-radius: 10px;
          height: 20px;
          line-height: 20px;
          padding: 0 6px;
          margin-bottom: 7px;
          margin-right: 5px;
        }
      }
      .item_creator {
        font-size: 12px;
        color: #454a5b;
        margin-bottom: 10px;
      }
      .item_joinedClerk {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 13px;
        .join_tips {
          display: flex;
          align-items: center;
          .join_img {
            width: 16px;
            height: 16px;
            margin-right: 3px;
          }
          .join_text {
            font-size: 11px;
            color: #454a5b;
            opacity: 0.5;
          }
        }
        .joined_tips {
          display: flex;
          align-items: center;
          position: relative;
          img {
            width: 16px;
            height: 16px;
            border-radius: 50%;
            border: 1px solid #fff;
            margin-left: -6px;
          }
        }
        .join_user {
          display: flex;
          align-items: center;

          .join_user_img {
            width: 12px;
            height: 12px;
            margin-right: 5px;
          }
          .join_user_num {
            font-size: 13px;
            color: #000000;
            opacity: 0.5;
          }
        }
      }
      .join_btn {
        width: 143px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        background: #ffffff;
        border-radius: 15px;
        font-size: 13px;
        color: #191817;
        &.exit_audit {
          opacity: 0.5;
        }
      }
    }
  }
  .joinDialog_header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    border-bottom: 1px solid #f5f5f5;
    padding: 12px 10px;
    box-sizing: border-box;
    .header_title {
      font-size: 15px;
      color: #333333;
      text-align: center;
      flex: 1;
    }
  }
  .joinDialog_title {
    text-align: center;
    font-weight: bold;
    font-size: 15px;
    color: #333333;
    margin-top: 22px;
    margin-bottom: 16px;
  }
  .joinDialog_label {
    display: flex;
    flex-direction: column;
    font-weight: 500;
    font-size: 15px;
    color: #333333;
    padding-left: 20px;
    margin-bottom: 20px;
  }
  .upload_content {
    margin-top: 10px;
    margin-left: 40px;
  }
  .upload_btn {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 91px;
    height: 113px;
    background: #ffffff;
    border-radius: 6px;
    border: 1px solid #ededed;
    font-size: 10px;
    color: #999999;
    .van-icon-plus {
      margin-bottom: 10px;
      font-size: 18px;
    }
  }
  .joinDialog_bottom {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 28px;
    .joinDialog_btn {
      width: 164px;
      height: 35px;
      line-height: 35px;
      background: #42a5f6;
      border-radius: 17px;
      font-size: 13px;
      color: #ffffff;
      text-align: center;
    }
  }
  .exitDialog_desc {
    margin-left: 20px;
    font-size: 14px;
    color: #333333;
  }
  .exitDialog_bottom {
    display: flex;
    flex-direction: column;
    align-items: center;
    .exitDialog_primary {
      background: #42a5f6;
      border-radius: 17px;
      width: 164px;
      height: 35px;
      line-height: 35px;
      text-align: center;
      font-size: 13px;
      color: #ffffff;
      margin-bottom: 20px;
    }

    .exitDialog_default {
      font-size: 13px;
      color: #666666;
      margin-bottom: 24px;
    }
  }
  .applyDesc_input {
    border: 1px solid #fafafa;
    box-sizing: border-box;
    border-radius: 6px;
    margin: 20px;
    background-color: #fff;
    width: 286px;
  }
  .video_container {
    position: relative;
    width: 90px;
    height: 113px;
    .video_content {
      width: 90px;
      height: 113px;
      border-radius: 6px;
      background: #ddd;
    }
    .van-icon-play-circle {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      color: rgba(0, 0, 0, 0.3);
      z-index: 1;
    }
    .van-icon-clear {
      position: absolute;
      right: 0;
      top: 0;
      color: rgba(0, 0, 0, 0.7);
      z-index: 1;
    }
  }
}
</style>